import { draftedByPLL } from '../../Utils'
import { API_ENDPOINTS } from '../utils/endpoints'
import { callGraphQL, makeAPIRequest } from '../utils/request'
import { draftPicksByYearQuery } from './draft.queries'
import type {
  DraftPick,
  AllDraftPicksResponse,
  DraftPlayer,
} from './draft.types'

/**
 * Fetch all draft picks in a single year
 */
export async function fetchDraftPicksByYear(year?: number): Promise<DraftPick[]> {
  try {
    const res = await callGraphQL<AllDraftPicksResponse>(draftPicksByYearQuery, {
      year: year,
    })
    let filtered = draftedByPLL(res.draftPicks)
    return filtered
  } catch (error) {
    return []
  }
}

/**
 * Fetch all draft board players in a single year
 */
export const fetchDraftBoardPlayers = async (year: number): Promise<DraftPlayer[]> => {
  try {
    const res = await makeAPIRequest(API_ENDPOINTS.DRAFT_BOARD_PLAYERS, {
      method: 'GET',
      apiVersion: '4',
      queryParams: {
        year,
      },
    })
    
    if (res?.error) {
      res.error?.message && console.error(res.error?.message)
      return []
    }
    return res?.data
  } catch (error) {
    return []
  }
}
